import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { InterventionSuggestedLocation } from 'src/app/modules/intervention/models/intervention-suggested-location.model';
import { LocationBase } from '../models/location-base.model';

@Injectable({ providedIn: 'root' })
export class GeocodeService {
  baseUrl = '/geocode/address';

  constructor(private readonly http: HttpClient) {}

  getSuggestInterventionLocations$(queryString: string) {
    return this.http.get<InterventionSuggestedLocation[]>(`${this.baseUrl}/suggestlocations`, {
      params: { query: queryString },
    });
  }

  getInterventionAddressFromSuggestion$(suggestAddressText: string, isPoi: boolean = false, poiCode?: string) {
    return this.http.post<LocationBase>(`${this.baseUrl}/suggestion`, {
      suggestAddressText,
      poiCode,
      isPoi,
    });
  }

  getInterventionAddressFromCoordinates$(lat: number, lon: number) {
    return this.http.get<LocationBase>(`${this.baseUrl}/coordinates`, {
      params: { lat, lon },
    });
  }
}
